const navbar = () => {
  $(() => {
    // $("body").on("click", ".menu-item .material-symbols-outlined", function () {
    //   $(this).next(".dropdown-menu").toggleClass("d-none");
    // });

    // $("body").on("mouseenter", ".dropdown", function () {
    //   $(this).find(".dropdown-menu").removeClass("close");
    // });
    // $("body").on("mouseleave", ".dropdown", function () {
    //   $(this).find(".dropdown-menu").addClass("close");
    // });

    const dropdowns = document.querySelectorAll(".dropdown");
    dropdowns.forEach((dropdown) => {
      const dropdownMenu = dropdown.querySelector(".dropdown-menu");

      const dropdownToggle = dropdown.querySelector(".dropdown-toggle");
      dropdownToggle.addEventListener("click", (e) => {
        e.preventDefault();
        dropdowns.forEach((otherDropdown) => {
          if (otherDropdown !== dropdown) {
            otherDropdown.querySelector(".dropdown-menu").classList.add("close");
          } else {
            dropdownMenu.classList.toggle("close");
          }
        });
      });

      const dropdownBack = dropdown.querySelector(".back-btn");
      if (dropdownBack) {
        dropdownBack.addEventListener("click", (e) => {
          e.preventDefault();
          dropdownMenu.classList.add("close");
        });
      }
    });

    const navbarToggler = document.querySelector(".navbar-toggler");
    if (navbarToggler) {
      navbarToggler.addEventListener("click", () => {
        navbarToggler.classList.toggle("collapsed");
        $("#navbarToggler").toggleClass("aperto");
        $("body").toggleClass("noscroll");
      });
    }

    window.addEventListener("scroll", () => {
      var scroll = $(window).scrollTop();
      var header_top = $(".header").outerHeight();

      if (scroll > header_top) {
        $("body").addClass("stickyHeader");
      } else {
        $("body").removeClass("stickyHeader");
      }
    });
  });
};

export default navbar;
